// extracted by mini-css-extract-plugin
module.exports = {"cardBottom":"CrossSegmentCard-CardBottom-module--card-bottom--162Md"};